export enum BillingActionType {
  Set = 'customer/SET_BILLING',
}
